export const removeTimezoneOffset = (date, asNew = false) =>
{
  let result = date;
  if (asNew)
  {
    result = new Date(date.toJSON());
  }
  result.setMinutes(result.getMinutes() + (new Date(result.toJSON())).getTimezoneOffset());
  return result;
};

export const addTimezoneOffset = (date, asNew = false) =>
{
  let result = date;
  if (asNew)
  {
    result = new Date(date.toJSON());
  }
  result.setMinutes(result.getMinutes() - (new Date(date.toJSON())).getTimezoneOffset());
  return result;
};

export const convertJsonToDate = (date, compensateTimezoneOffset = false) =>
{
  if (date)
  {
    const result = new Date(date);
    if (compensateTimezoneOffset)
    {
      removeTimezoneOffset(result);
    }
    return result;
  }
  return undefined;

};

export const convertDateToJson = (date, compensateTimezoneOffset = false) =>
{
  if (date)
  {
    const result = new Date(date.toJSON());
    if (compensateTimezoneOffset)
    {
      addTimezoneOffset(result);
    }
    return result.toJSON();
  }
  return undefined;
};

export const convertDateToLocaleDateString = (date) => date?.toLocaleDateString() ?? '';

export const getFormattedDate = (currentDate) =>
{
  if (currentDate === undefined || currentDate === null)
  {
    return '';
  }
  const year = currentDate?.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate?.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
export const getQueryString = (params) => {
  const qs = [];
  Object.keys(params).forEach(key => {
      const value = params[key];
      if (isDefined(value)) {
          if (Array.isArray(value)) {
              value.forEach(value => {
                  qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
              });
          } else {
              qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
          }
      }
  });
  if (qs.length > 0) {
      return `?${qs.join('&')}`;
  }
  return '';
}
